import AxiosProvider from '@/app/utils/api/axios-provider';

export default {
  getUserLoginNamesList(clientId: number) {
    return AxiosProvider.adminApiClient.get(`/users/login-names/${clientId}`);
  },
};
